import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCollateral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M4.055 11.823A8.75 8.75 0 1 1 5.973 18a.75.75 0 0 0-1.166.943 10.232 10.232 0 0 0 7.972 3.807c5.661 0 10.25-4.59 10.25-10.25S18.44 2.25 12.78 2.25c-5.413 0-9.845 4.195-10.224 9.512l-.678-.9a.75.75 0 0 0-1.198.902l1.702 2.26a.75.75 0 0 0 1.05.147l2.26-1.702a.75.75 0 1 0-.903-1.198l-.733.552Z"
    />
    <path
      fill="#F7A600"
      d="M15.329 10.49a.581.581 0 0 1-.576.586.581.581 0 0 1-.576-.586c0-.324.258-.586.576-.586.318 0 .576.262.576.586Z"
    />
    <path
      fill="#F7A600"
      d="m17.893 7.966-.128-.51-.503-.133c-.904-.243-2.09-.03-3.216.456a9.175 9.175 0 0 0-3.108 2.229c-.908.065-1.667.468-2.371 1.185l-.758.77 1.957 1.34c-.035.603.24 1.212.65 1.63.407.414 1 .694 1.584.666l1.32 2.022.761-.775c.72-.733 1.123-1.51 1.178-2.45a9.47 9.47 0 0 0 2.181-3.16c.479-1.144.692-2.348.453-3.27Zm-3.266 1.206c.753-.325 1.409-.448 1.877-.436.012.475-.111 1.14-.432 1.906a7.939 7.939 0 0 1-2.039 2.84l-.269.238.013.362c.014.394-.06.74-.27 1.092l-.93-1.425-.597.328c-.003.001-.053.022-.16-.004a.759.759 0 0 1-.353-.21.763.763 0 0 1-.204-.355c-.025-.111-.002-.164.002-.17l.328-.607-1.385-.948c.337-.203.673-.28 1.054-.27l.352.008.23-.273a7.68 7.68 0 0 1 2.783-2.076ZM9.979 16.584c-.584.606-2.135.877-2.135.877s.323-1.673.846-2.216c.443-.46 1.086-.544 1.449-.167s.283 1.046-.16 1.506Z"
    />
  </svg>
);
export default SvgTwoColorCollateral;
